<template>
  <v-container class="fill-height text-center" fluid>
    <v-container fluid>
      <div class="center-center">
        <v-card
          class="elevation-0 signin-wrapper"
          id="register-form"
          :class="{ register: form == 'register' }"
        >
          <v-card-title>
            <h2 class="mx-auto">REGISTER NEW ACCOUNT</h2>
          </v-card-title>
          <v-card-subtitle>ATX-CMS</v-card-subtitle>

          <v-card-text class="pb-0">
            <v-card class="register">
              <v-card-text>
                <v-form ref="registrationForm" v-model="valid">
                  <v-row class="py-3">
                    <v-col sm="12" md="6" class="py-0">
                      <v-text-field
                        label="First Name"
                        name="FirstName"
                        required
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                    <v-col sm="12" md="6" class="py-0">
                      <v-text-field
                        label="Last Name"
                        name="LastName"
                        required
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                    <v-col sm="12" class="py-0">
                      <v-text-field
                        label="E-mail"
                        name="Email"
                        v-model="email"
                        :rules="[rules.emailRequired, rules.emailValid]"
                        required
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                    <v-col sm="12" class="py-0">
                      <v-text-field
                        label="Enter Password"
                        name="Password"
                        v-model="password"
                        :type="passwordShow ? 'text' : 'password'"
                        :rules="[rules.required, rules.min]"
                        :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="passwordShow = !passwordShow"
                        v-on:keyup.enter="signIn"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        color="blue-grey lighten-3"
                        @click="$refs.registrationForm.reset()"
                      >
                        CLEAR
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        :dark="valid"
                        :disabled="!valid"
                        color="blue darken-3"
                        @click="register"
                      >
                        REGISTER
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-card-text>

          <v-card-actions>
            <v-btn text @click="$emit('signIn')" class="mx-auto">
              BACK TO SIGN-IN FORM
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-container>
  </v-container>
</template>

<script>
/* eslint-disable */
import { firebaseApp as firebase, dbProfiles } from "@/config/firebase";
import config from "@/config/app";

export default {
  name: "Register",
  data: () => ({
    form: "signin",
    stars: false,
    valid: false,
    email: "",
    password: "",
    checkbox: false,
    passwordShow: false,
    rules: {
      emailRequired: (v) => !!v || "E-mail is required",
      emailValid: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
      emailMatch: () => `The email and password you entered don't match`,
    },
  }),
  methods: {
    register() {
      const _this = this;
      let form = this.$refs.registrationForm.$el; // need $el to actually access dom element
      let formData = new FormData(form);
      let userProfile = {};
      for (var key of formData.keys()) {
        userProfile[key] = formData.get(key);
      }
      //console.log("userProfile", userProfile);

      // REGISTER USER AND INSTALL DEFAULT VALUES EX. ROLE / LANG / ETC...
      const registerUser = firebase
        .auth()
        .createUserWithEmailAndPassword(userProfile.email, userProfile.Password)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          userProfile.role = config.defaultUser.role;
          userProfile.lang = config.defaultUser.lang;
          userProfile.uid = user.uid; // add uid to userProfile
          this.saveUserProfile(userProfile); // save to profile database
        })
        .catch((error) => {
          // var errorCode = error.code;
          // var errorMessage = error.message;
          console.log("Register", error);
        });
    },
    saveUserProfile(userProfile) {
      delete userProfile.Password; // removes password so not visible in database
      userProfile[
        "FullName"
      ] = `${userProfile.FirstName} ${userProfile.LastName}`.trim();

      dbProfiles.add(userProfile).then(() => {
        this.$app.alert(`${userProfile.email} has been registered`);
      });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.siginInForm.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    keyPress(evtobj) {
      // listens for keypress
      //console.log("keypress", evtobj);

      if (evtobj.keyCode == 83 && evtobj.altKey) {
        // listens for alt+s
        this.stars = !this.stars;
      }
    },
    async checkRoute() {
      if (await this.$app.user.loggedIn) {
        this.$router.push($app.defaultPage);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.checkRoute();
    }, 1000);
    document.onkeydown = this.keyPress;
  },
};
</script>

<style lang="scss">
.signin-wrapper {
  background: none !important;
  width: 100%;
  max-width: 400px;

  &.register {
    max-width: 500px;
  }
}

@mixin sp-layout {
  @media screen and (max-width: 750px) {
    @content;
  }
}

.atx-gradient-blue {
  display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   min-height: 100vh;
  background: radial-gradient(ellipse at bottom, #0d1d31 0%, #0c0d13 100%);
  overflow: hidden;
}

@function random_range($min, $max) {
  $rand: random();
  $random_range: $min + floor($rand * (($max - $min) + 1));
  @return $random_range;
}

.stars {
  position: fixed;
  top: 0;
  left: 0;
  width: 150%;
  height: 150%;
  transform: rotate(-45deg);
}

.star {
  $star-count: 50;
  --star-color: var(--primary-color);
  --star-tail-length: 6em;
  --star-tail-height: 2px;
  --star-width: calc(var(--star-tail-length) / 6);
  --fall-duration: 9s;
  --tail-fade-duration: var(--fall-duration);

  position: absolute;
  top: var(--top-offset);
  left: 35vw;
  width: var(--star-tail-length);
  height: var(--star-tail-height);
  color: var(--star-color);
  background: linear-gradient(45deg, currentColor, transparent);
  border-radius: 50%;
  filter: drop-shadow(0 0 6px currentColor);
  transform: translate3d(104em, 0, 0);
  animation: fall var(--fall-duration) var(--fall-delay) linear infinite,
    tail-fade var(--tail-fade-duration) var(--fall-delay) ease-out infinite;

  @include sp-layout {
    // For mobile performance, tail-fade animation will be removed QAQ
    animation: fall var(--fall-duration) var(--fall-delay) linear infinite;
  }

  @for $i from 1 through $star-count {
    &:nth-child(#{$i}) {
      --star-tail-length: #{random_range(500em, 750em) / 100};
      --top-offset: #{random_range(0vh, 10000vh) / 100};
      --fall-duration: #{random_range(6000, 12000s) / 1000};
      --fall-delay: #{random_range(0, 10000s) / 1000};
    }
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    top: 0;
    left: calc(var(--star-width) / -2);
    width: var(--star-width);
    height: 100%;
    background: linear-gradient(45deg, transparent, currentColor, transparent);
    border-radius: inherit;
    animation: blink 2s linear infinite;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}

@keyframes fall {
  to {
    transform: translate3d(-30em, 0, 0);
  }
}

@keyframes tail-fade {
  0%,
  50% {
    width: var(--star-tail-length);
    opacity: 1;
  }

  70%,
  80% {
    width: 0;
    opacity: 0.4;
  }

  100% {
    width: 0;
    opacity: 0;
  }
}

@keyframes blink {
  50% {
    opacity: 0.6;
  }
}
// Fixes Autofill color
// input:-webkit-autofill,
// input:-webkit-autofill:hover,
// input:-webkit-autofill:focus textarea:-webkit-autofill,
// textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
// select:-webkit-autofill,
// select:-webkit-autofill:hover,
// select:-webkit-autofill:focus {
//   -webkit-box-shadow: 0 0 0px 30px #1f2631 inset !important;
//   -webkit-text-fill-color: #ffffff;
// }
</style>
